export default {"src":"/_next/static/media/teeth-left-mobile.d5b81d3e.svg","height":140,"width":84,"blurWidth":0,"blurHeight":0};